import React from 'react'
import get from 'lodash/get'
import set from 'lodash/set'
import clone from 'lodash/clone'
import Searchbar from '../searchbar/searchbar-vendor-cost'
import VendorCostTable from '../table/table-vendor-cost'
import { addButton } from '../helper/button'
import { ConfirmSaveForm, AddVendorForm } from '../form'

export default class VendorTab extends React.Component {
  static getDerivedStateFromProps(nextProps, prevState) {
    const tempState = prevState
    if (get(nextProps, 'projectByID')
    && JSON.stringify(get(nextProps, 'projectByID')) !== JSON.stringify(prevState.projectByID)
    ) {
      const projectByID = get(nextProps, 'projectByID')
      set(tempState, 'projectByID', projectByID)
      set(tempState, 'vendors', projectByID.vendors)
    }
    if (get(nextProps, 'editVendor') !== get(prevState, 'editVendor')) {
      set(tempState, 'editVendor', get(nextProps, 'editVendor'))
    }
    return tempState
  }

  state={
    editVendor: false,
    showAddVendor: false,
    showConfirmSave: false,

    vendor_name: '',
    vendor_sub_project_code: '',
    vendor_description: '',
    vendor_cost: 0,
    vendor_price: 0,
    vendor_man_days: 0,
    search_vendor: '',
  }

  shouldComponentUpdate(nextProps, nextState) {
    if (JSON.stringify(nextProps) === JSON.stringify(this.props)
    && JSON.stringify(this.state) === JSON.stringify(nextState)) return false
    return true
  }

  confirmEditVendorCost = () => {
    const editProjectInformation = get(this.props, 'editProjectInformation')
    const projectByID = this.state.projectByID
    const payload = { ...projectByID }
    delete payload.project_type
    delete payload.created
    delete payload.project_approve_status
    delete payload.created_by
    delete payload.project_number
    delete payload.__v
    delete payload.project_status
    delete payload._id
    delete payload.updated_by
    payload.vendors = this.state.vendors
    editProjectInformation(payload)
    this.setState({ showConfirmSave: !this.state.showConfirmSave })
    get(this.props, 'clickEditVendor')()
  }

  addVendor = () => {
    const oldVendors = this.state.vendors
    const vendor = {}
    let vendors = []
    vendor.vendor_name = this.state.vendor_name
    vendor.sub_project_code = this.state.vendor_sub_project_code
    vendor.description = this.state.vendor_description
    vendor.cost = this.state.vendor_cost
    vendor.price = this.state.vendor_price
    vendor.man_days = this.state.vendor_man_days
    vendors = [...oldVendors, vendor]
    this.setState({
      vendors,
      showAddVendor: !this.state.showAddVendor,
    })
  }

  deleteVendor = (id) => {
    const vendors = clone(this.state.vendors)
    vendors.splice(id, 1)
    this.setState({ vendors })
  }

  clickAddVendor = () => {
    this.setState({
      showAddVendor: !this.state.showAddVendor,
      vendor_name: '',
      vendor_sub_project_code: '',
      vendor_description: '',
      vendor_cost: 0,
      vendor_price: 0,
      vendor_man_days: 0,
    })
  }

  handleChangeCost = (e) => {
    const newVendors = this.state.vendors
    const vendor = this.state.vendors[e.target.id]
    const field = e.target.name
    if (field === 'price' || field === 'cost' || field === 'man_days') {
      vendor[field] = parseFloat(e.target.value.replace(/,/g, ''))
    } else {
      vendor[field] = e.target.value
    }
    newVendors[e.target.id] = vendor
    this.setState({ vendors: newVendors })
  }

  handleInput = (e) => {
    this.setState({ [e.target.name]: e.target.value })
  }
  /* eslint no-underscore-dangle: 0 */
  render() {
    const getProjectInformationByID = get(this.props, 'getProjectInformationByID')
    const clickEditVendor = get(this.props, 'clickEditVendor')
    return (
      <div style={ { marginLeft: 15, marginRight: 15 } }>
        <ConfirmSaveForm
          open={ this.state.showConfirmSave }
          toggle={ () => this.setState({ showConfirmSave: !this.state.showConfirmSave }) }
          confirmSave={ this.confirmEditVendorCost }
        />
        <AddVendorForm
          open={ this.state.showAddVendor }
          button={ addButton('addVendor', () => this.addVendor(), () => this.setState({ showAddVendor: !this.state.showAddVendor })) }
          handleInput={ this.handleInput }
          toggle={ () => this.setState({ showAddVendor: !this.state.showAddVendor }) }
          vendor_cost={ this.state.vendor_cost }
          vendor_price={ this.state.vendor_price }
          vendor_man_days={ this.state.vendor_man_days }
        />
        <Searchbar
          editVendor={ this.state.editVendor }
          projectByID={ get(this.props, 'projectByID') }
          rSelected={ get(this.props, 'rSelected') }
          clickEdit={ () => clickEditVendor() }
          clickAddVendor={ this.clickAddVendor }
          confirmEditVendor={ () =>
            this.setState({ showConfirmSave: !this.state.showConfirmSave }) }
          cancelEdit={ () => {
            clickEditVendor()
            this.setState({ projectByID: null })
            getProjectInformationByID()
          } }
        />
        <VendorCostTable
          editVendor={ this.state.editVendor }
          projectByID={ get(this.props, 'projectByID') }
          rSelected={ get(this.props, 'rSelected') }
          vendors={ this.state.vendors }
          search_vendor={ this.state.search_vendor }
          handleChangeCost={ this.handleChangeCost }
          deleteVendor={ this.deleteVendor }
        />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/project-information/tab-content/tab-vendor-cost.js